<template>
  <BfFlex
    class="filter-checkbox"
    align="center"
  >
    <input
      :id="uuid"
      v-model="model"
      :style="
        iconDefault && {
          'background-image': `url(${model ? iconSelected : iconDefault})`,
        }
      "
      type="checkbox"
    />
    <label :for="uuid">{{ label }}</label>
  </BfFlex>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import { BfFlex } from '@finetic/bikefitting-ui'
import { CommonFilterIcons } from '@/types/filter'
import { v4 as uuidv4 } from 'uuid'

const model = defineModel({ type: Boolean })

const props = defineProps<{
  label: string
  icons?: CommonFilterIcons
}>()

const uuid = ref(uuidv4())

const iconDefault = computed(() => props.icons?.default ?? '')
const iconSelected = computed(() => props.icons?.selected ?? '')
</script>

<style lang="scss">
.filter-checkbox {
  input[type='checkbox'] {
    flex: 0 0 4.8rem;
    width: 4.8rem;
    height: 4.8rem;
    background-color: var(--color-light);
    border: solid 0.1rem var(--color-dark-20);
    border-radius: 0.4rem;
    appearance: none;

    &:hover {
      background-color: var(--color-dark-2);
    }

    &:checked {
      background-color: var(--color-primary);
    }
  }

  label {
    text-transform: none;
  }
}
</style>
